import { faGrid2, faHeart } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CartIcon from 'Component/CartIcon';
import HomeIcon from 'Component/HomeIcon';
import MenuIcon from 'Component/MenuIcon';
import SearchIcon from 'Component/SearchIcon';
import UserIcon from 'Component/UserIcon';
import FraseHead from 'Component/YBFraseHead';
import {
    NavigationTabs as SourceNavigationTabs
} from 'SourceComponent/NavigationTabs/NavigationTabs.component';
import { isSignedIn } from 'Util/Auth';
import { isApp } from 'Util/Mobile/isMobile';
import getStore from 'Util/Store';

import {
    ACCOUNT_TAB,
    CART_TAB,
    CMS_CATEGORIES_TAB,
    HOME_TAB,
    MENU_TAB,
    SEARCH_TAB
} from './NavigationTabs.config';

import './NavigationTabs.override.style';

/** @namespace Elganso/Component/NavigationTabs/Component */
export class NavigationTabsComponent extends SourceNavigationTabs {
    stateMap = {
        [HOME_TAB]: {
            home: true
        },
        [SEARCH_TAB]: {
            search: true
        },
        [MENU_TAB]: {
            menu: true
        },
        [CART_TAB]: {
            minicart: true
        },
        [ACCOUNT_TAB]: {
            account: true
        },
        [CMS_CATEGORIES_TAB]: {
            categories: true
        }
    };

    // Aqui se agregan por orden de aparicion los botones que queremos que aparezcan en la barra de navegacion.
    // Si se comenta alguno ya no aparece el icono en la barra.
    renderMap = {
        home: this.renderHomeButton.bind(this),
        search: this.renderSearchButton.bind(this),
        // categories: this.renderCategoriesButton.bind(this),
        menu: this.renderMenuButton.bind(this),
        minicart: this.renderMinicartButton.bind(this),
        account: this.renderAccountButton.bind(this)
    };

    shouldComponentUpdate(nextProps) {
        const {
            navigationState: { name: prevName },
            cartTotals: { items_qty: prevQty },
            device: prevDevice,
            haveNotifications: prevHaveNotifications
        } = this.props;

        const {
            navigationState: { name: nextName },
            cartTotals: { items_qty: nextQty },
            device: nextDevice,
            haveNotifications: nextHaveNotifications
        } = nextProps;

        return prevName !== nextName || nextQty !== prevQty || prevDevice !== nextDevice || prevHaveNotifications !== nextHaveNotifications;
    }

    renderHomeButton(isActive = false) {
        const { onHomeButtonClick } = this.props;

        return (
            <button
              key="home"
              block="NavigationTabs"
              elem="Button"
              aria-label="Home"
              onClick={ onHomeButtonClick }
            >
                <div
                  block="NavigationTabs"
                  elem="ButtonContainer"
                >
                    <HomeIcon isActive={ isActive } />
                </div>
            </button>
        );
    }

    renderMenuButton(isActive = false) {
        const { onMenuButtonClick } = this.props;

        return (
            <button
              key="menu"
              block="NavigationTabs"
              elem="Button"
              aria-label="Go to menu and search"
              onClick={ onMenuButtonClick }
            >
                <div
                  block="NavigationTabs"
                  elem="ButtonContainer"
                >
                    <MenuIcon isActive={ isActive } />
                </div>
            </button>
        );
    }

    renderSearchButton(isActive = false) {
        const { onSearchButtonClick } = this.props;

        return (
            <button
              key="search"
              block="NavigationTabs"
              elem="Button"
              aria-label="search"
              onClick={ onSearchButtonClick }
            >
                <div
                  block="NavigationTabs"
                  elem="ButtonContainer"
                >
                    <SearchIcon isActive={ isActive } />
                </div>
            </button>
        );
    }

    renderAccountButton(isActive = false) {
        const { onMyAccountButtonClick, haveNotifications } = this.props;
        let showNotifications = false;

        if (isSignedIn()) {
            if (haveNotifications) {
                showNotifications = true;
            }
        }

        return (
            <button
              key="account"
              block="NavigationTabs"
              elem="Button"
              onClick={ onMyAccountButtonClick }
              aria-label="Open my account"
            >
                <div
                  block="NavigationTabs"
                  elem="ButtonContainer"
                >
                    <UserIcon isActive={ isActive } />
                    <div
                      block="NavigationTabs"
                      elem="NumberNotifications"
                      key={ haveNotifications }
                      className={ showNotifications ? '' : 'hidePoint' }
                    >
                        { haveNotifications }
                    </div>
                </div>
            </button>
        );
    }

    renderMinicartButton(isActive = false) {
        const { onMinicartButtonClick } = this.props;

        return (
            <button
              key="minicart"
              block="NavigationTabs"
              elem="Button"
              onClick={ onMinicartButtonClick }
              aria-label="Minicart"
            >
                <div
                  block="NavigationTabs"
                  elem="ButtonContainer"
                >
                    <div block="Header" elem="MinicartWrapper">
                        <div
                          block="Header"
                          elem="Button"
                          mix={ { block: 'NavigationTabs', elem: 'Icon', mods: { isActive } } }
                          mods={ { isVisible: true, type: 'minicart' } }
                        >
                            <CartIcon isActive={ isActive } />
                            <FontAwesomeIcon className="heartIcon" icon={ faHeart } />
                        </div>
                    </div>
                </div>
            </button>
        );
    }

    renderCategoriesButton(_isActive = false) {
        const { onCategoriesButtonClick } = this.props;

        return (
            <button
              key="categories"
              block="NavigationTabs"
              elem="Button"
              onClick={ onCategoriesButtonClick }
              aria-label="Categories"
            >
                <div
                  block="NavigationTabs"
                  elem="ButtonContainer"
                >
                    <FontAwesomeIcon className="categoriesIcon" icon={ faGrid2 } />
                    <div
                      block="NavigationTabs"
                      elem="ButtonTitle"
                    >
                        <span>{ __('Categories') }</span>
                    </div>
                </div>
            </button>
        );
    }

    render() {
        const { navigationState: { isHidden = false } } = this.props;
        const { fraseHeadConfig = {} } = getStore().getState().ConfigReducer;

        if (!isApp()) {
            return null;
        }

        return (
            <footer
              block="NavigationTabs"
              mods={ { isHidden } }
              mix={ { block: 'FixedElement', elem: 'Bottom' } }
            >
                <FraseHead fraseHeadConfig={ fraseHeadConfig } />
                <nav block="NavigationTabs" elem="Nav">
                    { this.renderNavigationState() }
                </nav>
            </footer>
        );
    }
}

export default NavigationTabsComponent;
